/**
 * WelcomeModal — first-time / empty-state welcome.
 */
import { useAppStore } from '@/store/appStore';
import { Sparkles } from 'lucide-react';

export function WelcomeModal() {
  const { showWelcomeModal, setShowWelcomeModal } = useAppStore();

  if (!showWelcomeModal) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm"
      onClick={() => setShowWelcomeModal(false)}
    >
      <div
        className="w-full max-w-md rounded-xl border border-border bg-card shadow-xl p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3 mb-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
            <Sparkles className="h-6 w-6 text-primary" />
          </div>
          <div>
            <h2 className="font-semibold text-lg">Welcome to Event.Tools</h2>
            <p className="text-sm text-muted-foreground">Create stunning flyers with AI</p>
          </div>
        </div>
        <ul className="space-y-2 text-sm text-muted-foreground mb-6">
          <li>• Add entities (artists, venues, events) in the Entities panel</li>
          <li>• Upload logos and photos in Assets</li>
          <li>• Design on the canvas and use Generate for AI backgrounds</li>
          <li>• Chat with context to refine your designs</li>
        </ul>
        <button
          onClick={() => setShowWelcomeModal(false)}
          className="w-full rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        >
          Get started
        </button>
      </div>
    </div>
  );
}
